module.exports = __webpack_public_path__ + "static/media/EG.e82f6db6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/EG.svg
// module id = 245
// module chunks = 0